export const getFirstNonEmptyValue = (entries: Record<string, string>, preferredKey = '') => {
  if (preferredKey && entries[preferredKey]) {
    return entries[preferredKey];
  }

  const sortedKeys = Object.keys(entries).sort();
  for (const key of sortedKeys) {
    if (entries[key]) {
      return entries[key];
    }
  }

  return '';
};
